import { Manager } from '../core';

export const get = async () => {
	try {
		const {data}: any = await Manager.request(
			'get',
			'/discount/list.php',
		);
		return data;
	} catch (err) {
		throw new Manager.ServiceError('error.discount.get', err)
	}
}

export const create = async (code: string, discount: number) => {
	try {
		const {data}: any = await Manager.request(
			'post',
			'/discount/create.php',
			{ code, discount }
		);
		return data;
	} catch (err) {
		throw new Manager.ServiceError('error.discount.create', err)
	}
}

export const deleteDiscount = async (id: number) => {
	try {
		const {data}: any = await Manager.request(
			'get',
			`/discount/delete.php?id=${id}`,
		);
		return data;
	} catch (err) {
		throw new Manager.ServiceError('error.discount.deleteDiscount', err)
	}
}
